import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { COORDS, CITY_MAP } from "../data/destinations";
import { distKm, fmtKm } from "../lib/format";

export default function MapView({ city, items, onOpen, userLoc }) {
  const containerRef = useRef(null);
  const mapRef = useRef(null);
  const layerRef = useRef(null);
  const onOpenRef = useRef(onOpen);
  onOpenRef.current = onOpen;

  useEffect(() => {
    if (mapRef.current || !containerRef.current) return;
    const conf = CITY_MAP[city] || CITY_MAP.Jakarta;
    const map = L.map(containerRef.current, {
      center: conf.center, zoom: conf.zoom, scrollWheelZoom: false, attributionControl: false,
    });
    L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 19,
    }).addTo(map);
    mapRef.current = map;
    layerRef.current = L.layerGroup().addTo(map);
    // fix container sizing after mount
    setTimeout(() => map.invalidateSize(), 200);
    return () => { map.remove(); mapRef.current = null; };
  }, []); // eslint-disable-line

  // update view + markers when city/items change
  useEffect(() => {
    const map = mapRef.current;
    const layer = layerRef.current;
    if (!map || !layer) return;
    const conf = CITY_MAP[city] || CITY_MAP.Jakarta;
    map.setView(conf.center, conf.zoom);
    layer.clearLayers();
    const latlngs = [];
    items.forEach((d) => {
      const pos = COORDS[d.id];
      if (!pos) return;
      latlngs.push(pos);
      const icon = L.divIcon({
        className: "",
        html: `<div style="transform:translate(-50%,-100%);display:flex;flex-direction:column;align-items:center;">
          <div style="background:linear-gradient(105deg,#ff4560,#ff6b4a);color:#fff;font:700 11px 'Plus Jakarta Sans',sans-serif;padding:4px 9px;border-radius:999px;white-space:nowrap;box-shadow:0 4px 12px rgba(200,60,50,.35);">Rp${(d.price/1000)}k</div>
          <div style="width:10px;height:10px;background:#ff5a5f;transform:rotate(45deg);margin-top:-4px;box-shadow:0 3px 6px rgba(200,60,50,.3);"></div>
        </div>`,
        iconSize: [0, 0],
      });
      const marker = L.marker(pos, { icon }).addTo(layer);
      const dist = userLoc ? distKm(userLoc, pos) : null;
      const distHtml = dist != null ? `<div style="font-size:11px;color:#4f74c8;font-weight:700;margin-bottom:4px;">📍 ${fmtKm(dist)} dari kalian</div>` : "";
      const popup = `<div style="font-family:'Plus Jakarta Sans',sans-serif;min-width:150px;">
        <img src="${d.img}" style="width:100%;height:78px;object-fit:cover;border-radius:10px;margin-bottom:6px;"/>
        <div style="font-weight:800;font-size:13px;color:#1e1b18;">${d.name}</div>
        <div style="font-size:11px;color:#8a8278;margin:2px 0 6px;">${d.area} · ⭐ ${d.rating}</div>
        ${distHtml}
        <button data-open="${d.id}" style="width:100%;background:linear-gradient(105deg,#ff4560,#ff6b4a);color:#fff;border:0;border-radius:999px;padding:7px;font-weight:700;font-size:12px;cursor:pointer;">Lihat & pesan</button>
      </div>`;
      marker.bindPopup(popup);
      marker.on("popupopen", (e) => {
        const btn = e.popup.getElement().querySelector("[data-open]");
        if (btn) btn.onclick = () => onOpenRef.current(d);
      });
    });
    if (userLoc) {
      const uicon = L.divIcon({
        className: "",
        html: `<div style="transform:translate(-50%,-50%);"><div style="width:18px;height:18px;border-radius:50%;background:#4f74c8;border:3px solid #fff;box-shadow:0 0 0 6px rgba(79,116,200,.25);"></div></div>`,
        iconSize: [0, 0],
      });
      L.marker(userLoc, { icon: uicon }).addTo(layer).bindPopup("Lokasi kalian");
      latlngs.push(userLoc);
    }
    if (latlngs.length) map.fitBounds(L.latLngBounds(latlngs).pad(0.35), { maxZoom: 14 });
    setTimeout(() => map.invalidateSize(), 150);
  }, [city, items, userLoc]);

  return (
    <div className="overflow-hidden rounded-3xl border border-[#efeae4]" data-testid="map-view">
      <div ref={containerRef} style={{ height: 460, width: "100%" }} />
    </div>
  );
}
